export default "__VITE_ASSET__DuI5wL1A__"